// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import { downloadPDF } from "./pdf_download"
import { generateBeautifulClientPDF } from "./client_pdf"
import { jsPDF } from 'jspdf'

// Debug imports
console.log("Bootstrap imported:", typeof bootstrap);
console.log("downloadPDF imported:", typeof downloadPDF);
console.log("generateBeautifulClientPDF imported:", typeof generateBeautifulClientPDF);
console.log("jsPDF imported:", typeof jsPDF);

// Make downloadPDF available globally
window.downloadPDF = downloadPDF;
// Make client PDF generator available globally
window.generateBeautifulClientPDF = generateBeautifulClientPDF;
// Also make jsPDF available globally for debugging
window.jsPDF = jsPDF;

// Add a simple test function for PDF generation
window.testPDF = function() {
  try {
    console.log("Testing basic PDF generation...");
    const doc = new jsPDF();
    doc.text("Kismet Lab Test PDF", 10, 10);
    doc.save("test.pdf");
    console.log("Test PDF generated successfully");
    return true;
  } catch (error) {
    console.error("Error in test PDF generation:", error);
    return false;
  }
}
